const WhychooseUs = ({ whyshouldChooseData }) => {
  const backgroundImage = whyshouldChooseData.backgroundImage;
  const Image1 = whyshouldChooseData.Image1;
  const tagline = whyshouldChooseData.tagline;
  const pointsList1 = whyshouldChooseData.pointsList1;
  const pointsList2 = whyshouldChooseData.pointsList2;

  const renderPointsList = (points) =>
    points.map((point, index) => (
      <li key={index} className="why-choose-one__points-item ">
        <div className="icon">
          <span className="fa fa-check" />
        </div>
        <div className="text mt-[6%]">
          <p>{point}</p>
        </div>
      </li>
    ));
  

  return (
    <>
      {/* Desktop View */}
      <section className="md:flex hidden why-choose-one lg:h-[45vh]">
        {/* Background */}
        <div
          className="why-choose-one__bg"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
          data-jarallax=""
          data-speed="0.2"
          data-imgposition="50% 0%"
        />

        {/* Decorative Image */}
        <div
          className="why-choose-one__shape-2 wow slideInLeft"
          data-wow-delay="100ms"
          data-wow-duration="2500ms"
        >
          <img src={Image1} alt="Decorative Shape" />
        </div>

        {/* Content */}
        <div className="container">
          <div className="row">
            {/* Left Section */}
            <div className="col-xl-6 col-lg-6">
              <div className="why-choose-one__left">
                <div className="why-choose-one__inner lg:max-w-[550px] 2xl:mx-[-30%] max-w-[600px]">
                  <h3 className="text-[30px] font-medium leading-[50px]
                   text-white uppercase m-[24px] xl:ml-[-20px] sm:line-clamp-3">
                    {tagline}
                  </h3>
                </div>
              </div>
            </div>

            {/* Right Section */}
            <div className="col-xl-6 col-lg-6">
              <div className="why-choose-one__right lg:mt-[-14%] 2xl:mt-[-7%] mr-[-18%] !important">
                <div className="why-choose-one__points-box flex  justify-center items-center">
                  <ul className="why-choose-one__points-list list-unstyled ">
                    {renderPointsList(pointsList1)}
                  </ul>
                  <ul className="why-choose-one__points-list why-choose-one__points-list-2 list-unstyled">
                    {renderPointsList(pointsList2)}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mobile View */}
      <div
        className="md:hidden flex flex-col justify-center items-center h-s bg-cover bg-center relative"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className="absolute inset-0 bg-[#1a150e] opacity-65"></div>
        {/* Gray overlay */}
        <div className="relative z-10 text-center text-white px-4 py-8 w-full">
          <h1 className="section_title text-white">{tagline}</h1>
        </div>
        <div className="col-xl-6 col-lg-6 mb-3">
          <div className="why-choose-one__right mt-0 items-center">
            <div>
              <ul className="why-choose-one__points-list list-unstyled">
                {renderPointsList(pointsList1)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WhychooseUs;